import { List, Loading } from "react-vant";
import { useState,useImperativeHandle,forwardRef, useRef, useEffect } from "react";
import styled from "styled-components";
import { Empty } from "antd-mobile";
import { useIntl } from "react-intl";


export default forwardRef(ScrollList)
 function ScrollList({
  content,
  getData,
  pageSize = 10,
  onClick = () => {},
  ...props
},ref) {
  const [list, setList] = useState([]);
  const refList = useRef()
  const [finished, setFinished] = useState(false);
  const intl = useIntl()
  useImperativeHandle(ref, () => {
    return {
      clearData: () => {
       setList([])
      },
      refrushData: () => {
        onLoad()
      }
    };
  });

  const onLoad = async () => {
    if (getData) {
      let page = 1;
      page = Math.floor(list.length / pageSize);
      const data = await getData(page + 1);
      setList((v) => [...v, ...data]);
      if (data.length < pageSize) {
        setFinished(true);
      }
    } else {
      setFinished(true);
    }
  };
  return (
    <>
      {(!list || !list.length) && finished ? (
        <Empty description={
          intl.formatMessage({id:'common.no_data',defaultMessage:'暫無數據'})
        } imageStyle={{ width: 128 }} />
      ) : (
        <Wrapper {...props}>
          <List ref={refList} finished={finished} onLoad={onLoad} loadingText={
            intl.formatMessage({id:'common.loading',defaultMessage:'加載中...'})
          }>
            {list && list.length ? (
              <>
                {list.map((e, i) => (
                  content(e,i)
                ))}
              </>
            ) : null}
          </List>
        </Wrapper>
      )}
    </>
  );
}

const Wrapper = styled.div`
  /* height: 40.0rem;
  overflow: auto;
  border: 2px solid #000;
  border-radius: 2.2rem;
  box-shadow: 2px .25rem .0rem #000;
  overflow: auto; */
`;

// const ListsWrapper = styled.div`
//   border: 2px solid #000;
//   border-radius: 2.2rem;
//   box-shadow: 2px .25rem .0rem #000;
//   overflow: hidden;
// `;

const ListWrapper = styled.div`
  /* padding: 1.3rem 1.8rem;
  border-bottom: 1px solid #000;
  display: flex;
  justify-content: space-between;
  font-weight: bold;
  &:last-child {
    border: none;
  }
  &:first-child {
    border-bottom: 1px solid #000;
  } */
`;
